import { makeStyles, tokens } from "@fluentui/react-components";
import { textClip } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
export const usePlanTasksBoardViewStyles = makeStyles({
    projectManagerLogo: {
        height: "28px",
        width: "28px"
    },
    goalColumnHeaderTitle: {
        margin: tokens.spacingVerticalNone,
        minWidth: 0
    },
    goalColumnHeaderTitleButton: {
        background: "none",
        border: "none",
        padding: tokens.spacingVerticalNone,
        cursor: "pointer",
        fontFamily: "inherit",
        fontSize: "18px",
        fontWeight: tokens.fontWeightSemibold,
        lineHeight: tokens.lineHeightBase400,
        color: tokens.colorNeutralForeground1,
        textDecoration: "none",
        display: "block",
        width: "100%",
        ...textClip("ellipsis"),
        ":hover": {
            textDecoration: "underline"
        }
    }
});
